module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img44.fa9d593a.jpg";